import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

export const OPOFMI_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/opofmi/logo.png",
        alt: "Oakland Psychological Logo",
        style: { width: "250px", height: "100%", isMobile: { width: "200px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 50,
  state: "MI",
  departmentIds: [207, 211, 213, 215, 218, 234, 236, 252, 258],
};
